import React from "react";
import { useAppContext } from "../../AppProvider";

interface SwitchProps {
  name: string;
  checked: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  label?: string;
}

const Switch: React.FC<SwitchProps> = ({ checked, onChange, label, name }) => {
  const { dictionary } = useAppContext();

  return (
    <label
      style={{
        display: "inline-flex",
        alignItems: "center",
        cursor: "pointer",
      }}
    >
      <div className="form-check form-switch">
        <input
          name={name}
          title={
            checked ? dictionary.actions.desable : dictionary.actions.enable
          }
          onChange={onChange}
          checked={checked}
          type="checkbox"
          className="form-check-input form-check-input-info cursor-pointer"
        />
      </div>
      {label && <label className="label-2">{label}</label>}
    </label>
  );
};

export default Switch;
